module.exports = __webpack_public_path__ + "img/moovin.2c0327c6.png";